import { useEffect } from 'react';
import { get } from './axios_call';

export default (login, logout) => {
  useEffect(() => {
    let sourceOuter;
    get('current_user', true)
      .then(([res, source]) => {
        const token = localStorage.getItem('token');
        sourceOuter = source;
        login(token);
      })
      .catch(() => {
        logout();
      });
    return () => { sourceOuter.cancel(); };
  }, [login, logout]);
};
